import React from 'react'
import { Spinner } from '@okcredit/web-lib'
import { createUseStyles } from 'react-jss'

const loaderStyles = {
  container: {
    width: '100%',
    padding: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box'
  }
}

const useLoaderStyles = createUseStyles(loaderStyles)

const Loader = () => {
  const classes = useLoaderStyles()
  return (
    <div className={classes.container}>
      <Spinner size={40} />
    </div>
  )
}

export default Loader
